<template>
	<ul class="sidebar hidden-xs-only">
		<li class="item">
			<i class="iconfont icon-icon-email"></i>
			<div class="info">
				<span>邮箱 丨 635926424@qq.com</span>
				<img src="@/assets/images/jiantou.png" class="jiantou">
			</div>
		</li>
		<!-- <li class="item">
			<i class="iconfont icon-wechat"></i>
			<div class="info wechat-container">
				<img src="@/assets/images/wechat.jpg" class="wechat">
				<img src="@/assets/images/jiantou.png" class="jiantou">
			</div>
		</li> -->
		<li class="item">
			<i class="iconfont icon-tel"></i>
			<div class="info">
				<span>咨询热线 丨 0571-87311835</span>
				<img src="@/assets/images/jiantou.png" class="jiantou">
			</div>
		</li>
		<li class="item">
			<i class="iconfont icon-tubiao215"></i>
			<div class="info">
				<span>QQ 丨 635926424</span>
				<img src="@/assets/images/jiantou.png" class="jiantou">
			</div>
		</li>
		<li class="item" @click="goTop">
			<i class="iconfont icon-rocket"></i>
			<div class="info">
				<span>回到顶部</span>
				<img src="@/assets/images/jiantou.png" class="jiantou">
			</div>
		</li>
	</ul>
</template>
<script>
export default {
	methods: {
		goTop() {
			window.scrollTo({ top: 0 });
		}
	}
};
</script>

<style lang="scss" scoped>
.sidebar {
	position: fixed;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	z-index: 999;
	.item {
		width: 42px;
		height: 42px;
		background: #000;
		margin-bottom: 1px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		transition: all 0.3s;
		.iconfont {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 24px;
			color: #fff;
		}
		.info {
			position: absolute;
			top: 0;
			right: 50px;
			border: 1px solid #999;
			padding: 0 18px;
			height: 42px;
			background: #fff;
			opacity: 0;
			transition: all 0.3s;
			span {
				line-height: 42px;
				font-size: 14px;
				color: #999;
				white-space: nowrap;
			}
			.jiantou {
				width: 7px;
				height: 7px;
				position: absolute;
				top: 50%;
				right: -7px;
				transform: translateY(-50%);
			}
		}
		.wechat-container {
			height: auto;
			padding: 6px 6px;
			top: 50%;
			transform: translateY(-50%);
			.wechat {
				width: 82px;
				height: 82px;
			}
		}
		&:hover {
			background: #d8010f;
			overflow: inherit;
			.info {
				opacity: 1;
			}
		}
	}
}
</style>
